import React from "react";
const Info = ({ height = "16", width = "16", ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M8 13.25C6.60761 13.25 5.27226 12.6969 4.28769 11.7123C3.30312 10.7277 2.75 9.39239 2.75 8C2.75 6.60761 3.30312 5.27226 4.28769 4.28769C5.27226 3.30312 6.60761 2.75 8 2.75C9.39239 2.75 10.7277 3.30312 11.7123 4.28769C12.6969 5.27226 13.25 6.60761 13.25 8C13.25 9.39239 12.6969 10.7277 11.7123 11.7123C10.7277 12.6969 9.39239 13.25 8 13.25ZM8 14C9.5913 14 11.1174 13.3679 12.2426 12.2426C13.3679 11.1174 14 9.5913 14 8C14 6.4087 13.3679 4.88258 12.2426 3.75736C11.1174 2.63214 9.5913 2 8 2C6.4087 2 4.88258 2.63214 3.75736 3.75736C2.63214 4.88258 2 6.4087 2 8C2 9.5913 2.63214 11.1174 3.75736 12.2426C4.88258 13.3679 6.4087 14 8 14Z"
        fill="var(--whiteToBlack)"
        fillOpacity="0.7"
      />
      <path
        d="M8.69746 6.941L6.97996 7.15625L6.91846 7.44125L7.25596 7.5035C7.47646 7.556 7.51996 7.6355 7.47196 7.85525L6.91846 10.4563C6.77296 11.129 6.99721 11.4455 7.52446 11.4455C7.93321 11.4455 8.40796 11.2565 8.62321 10.997L8.68921 10.685C8.53921 10.817 8.32021 10.8695 8.17471 10.8695C7.96846 10.8695 7.89346 10.7248 7.94671 10.4698L8.69746 6.941ZM8.74996 5.375C8.74996 5.57391 8.67095 5.76468 8.53029 5.90533C8.38964 6.04598 8.19888 6.125 7.99996 6.125C7.80105 6.125 7.61029 6.04598 7.46963 5.90533C7.32898 5.76468 7.24996 5.57391 7.24996 5.375C7.24996 5.17609 7.32898 4.98532 7.46963 4.84467C7.61029 4.70402 7.80105 4.625 7.99996 4.625C8.19888 4.625 8.38964 4.70402 8.53029 4.84467C8.67095 4.98532 8.74996 5.17609 8.74996 5.375Z"
        fill="var(--whiteToBlack)"
        fillOpacity="0.7"
      />
    </svg>
  );
};
export default Info;
